'use client'

import { useMemo } from 'react'
import { Button } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = Omit<ComponentProps<typeof Button>, 'url' | 'urlProps'>

const EmailButton = (props: Props) => {
  const translate = useTranslate('business.pro_integrations.email_button')

  const url = useMemo(() => {
    const emailAddress = translate('email_address')
    const subject = translate('subject')
    const body = translate('body')

    return `mailto:${encodeURIComponent(emailAddress)}?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(body)}`
  }, [translate])

  return <Button url={url} urlProps={{ target: '_blank' }} {...props} />
}

export default EmailButton
